import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useLogin from "../../hooks/useLogin";
import Avatar from "./Avatar";
import ItemsSidebar from "./ItemsSidebar";
import SidebarGroup from "./SidebarGroup";
import {
  urlAbogado,
  urlCli,
  urlConta,
  urlPaths,
  urlProv,
  ASSETS_URL,
} from "./utils/urls";

export default function Sidebar() {
  const { pathname } = useLocation();
  const { user, user_rol, imagen } = useLogin();
  const [Collapse, setCollapse] = useState(null);

  // Sólo los proveedores y clientes suben foto; el resto usa su inicial.
  const carpetaDeFotos =
    (user_rol === "proveedor" && "PROVEEDOR") ||
    (user_rol === "cliente" && "CLIENTE") ||
    null;
  const fotoDelUsuario =
    carpetaDeFotos && imagen
      ? `${ASSETS_URL}images/fotos/${carpetaDeFotos}/${imagen}`
      : null;

  const CollapseShow = (key) => {
    if (Collapse === key) {
      setCollapse(null);
    } else {
      setCollapse(key);
    }
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <div
        className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top"
        style={{ zIndex: 1031 }}
      >
        {/* El mismo lockup del login. El logo-mini.svg es blanco y sobre menta
            no se vería; este es el del leon con la firma, en transparente. */}
        <Link className="sidebar-brand brand-logo" to="/">
          <img
            src={`${process.env.PUBLIC_URL}/logo-login.png`}
            alt="LCI — Siempre es posible"
            className="sidebar-logo"
          />
        </Link>
        {/* Con la barra angosta el lockup no cabe y el logo-mini se veía como
            una letra suelta gigante. Un monograma escrito ocupa lo justo y se
            lee igual de bien. */}
        <Link className="sidebar-brand brand-logo-mini" to="/" aria-label="LCI">
          <span className="sidebar-monograma">LCI</span>
        </Link>
      </div>
      <ul className="nav">
        <li className="nav-item profile">
          <div className="profile-desc">
            <div className="profile-pic">
              {/* Sin el punto verde de "en línea" del tema anterior: esta app
                  no tiene presencia, y encima se montaba sobre el nombre. */}
              <Avatar nombre={user} src={fotoDelUsuario} tamano={40} />
              <div className="profile-name">
                <h5
                  className="mb-0 font-weight-normal text-white"
                  style={{ fontSize: 12 }}
                >
                  {user}
                </h5>
                <span style={{ textTransform: "capitalize" }}>{user_rol}</span>
              </div>
            </div>
          </div>
        </li>
        <li className="nav-item nav-category">
          <span className="nav-link text-white">
            Barra de navegación
          </span>
        </li>
        {((user_rol === "super administrador" || user_rol === "administrador") &&
          urlPaths.map((item, index) =>
            item.subMenu ? (
              <SidebarGroup
                key={item.state}
                item={item}
                pathname={pathname}
                abierto={Collapse === index}
                onToggle={() => CollapseShow(index)}
              />
            ) : (
              <ItemsSidebar
                key={item.path}
                item={item}
                index={index}
                pathname={pathname}
              />
            )
          )) ||
          (user_rol === "contabilidad" &&
            urlConta.map((item, index) => (
              <ItemsSidebar
                key={item.path}
                item={item}
                index={index}
                pathname={pathname}
              />
            ))) ||
          (user_rol === "cliente" &&
            urlCli.map((item, index) => (
              <ItemsSidebar
                key={item.path}
                item={item}
                index={index}
                pathname={pathname}
              />
            ))) ||
          (user_rol === "proveedor" &&
            urlProv.map((item, index) => (
              <ItemsSidebar
                key={item.path}
                item={item}
                index={index}
                pathname={pathname}
              />
            )))}

        {user_rol === "abogado" &&
          urlAbogado.map((item, index) => (
            <ItemsSidebar
                key={item.path}
                item={item}
                index={index}
                pathname={pathname}
              />
          ))}
      </ul>
    </nav>
  );
}
